import * as React from 'react';

import {
  DialogTitle,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Button,
  CircularProgress,
} from '@botco/library';
import { useLogout } from '~/hooks/useLogout';

type PropsType = {
  open: boolean;
};

export const IdleDialog = ({ open }: PropsType) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const logout = useLogout();

  const handleLogout = async () => {
    setIsLoading(true);
    try {
      await logout();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Logout error:', error);
      setIsLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Session Expired!!</DialogTitle>
      <DialogContent>
        <Typography id="alert-dialog-description">
          Your session has expired. You will be redirected to Login page.
        </Typography>
        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button
            onClick={handleLogout}
            disabled={isLoading}
            color="primary"
            variant="contained"
          >
            {isLoading ? (
              <CircularProgress size={16} sx={{ color: 'common.white' }} />
            ) : (
              'OK'
            )}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};
